import React from 'react'
import ContributionsPageSkeleton from './components/ContributionsComponents/ContributionsPageSkeleton'

export default function ChangeLogPageSkeleton(): JSX.Element {
  return <ContributionsPageSkeleton />
}
